var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iin_1962_12357)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5.99997,
    width: 36,
    height: 36.0001,
    rx: 8,
    fill: "url(#paint0_linear_1962_12357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9643 14H17.8651C16.3126 14 15.0498 15.1336 15.0498 16.5285V17.1096C15.0498 18.5045 16.3126 19.6396 17.8651 19.6396L24.6865 19.6561C24.792 19.6569 24.893 19.6993 24.9675 19.7741C25.042 19.8489 25.084 19.95 25.0844 20.0555C25.0844 20.108 25.074 20.1599 25.054 20.2084C25.0339 20.2568 25.0045 20.3009 24.9674 20.338C24.9303 20.3751 24.8863 20.4045 24.8378 20.4245C24.7894 20.4446 24.7374 20.4549 24.685 20.4549H23.4537L22.7615 20.464C22.5551 20.4606 22.35 20.4984 22.1584 20.5753C21.9668 20.6522 21.7924 20.7666 21.6456 20.9118C21.4987 21.0569 21.3823 21.23 21.3032 21.4207C21.2241 21.6114 21.1839 21.816 21.185 22.0225V32.0481C21.1838 32.304 21.2332 32.5576 21.3303 32.7944C21.4274 33.0312 21.5703 33.2464 21.7508 33.4278C21.9314 33.6092 22.146 33.7531 22.3823 33.8513C22.6186 33.9495 22.872 34 23.1279 34H24.8802C25.3966 33.9981 25.8911 33.7915 26.2556 33.4257C26.62 33.0598 26.8246 32.5645 26.8246 32.0481V22.5886C26.8246 22.4827 26.8667 22.3811 26.9416 22.3062C27.0165 22.2313 27.1181 22.1892 27.224 22.1892H29.5934C30.034 22.1894 30.4704 22.1028 30.8775 21.9343C31.2847 21.7658 31.6546 21.5188 31.9663 21.2072C32.2779 20.8957 32.5251 20.5259 32.6938 20.1188C32.8625 19.7118 32.9493 19.2754 32.9493 18.8348V16.991C32.9485 16.199 32.6339 15.4396 32.0745 14.879C31.515 14.3184 30.7563 14.0024 29.9643 14ZM24.4087 32.2478H23.709C23.6069 32.2478 23.5059 32.2277 23.4116 32.1886C23.3173 32.1494 23.2317 32.0921 23.1596 32.0199C23.0875 31.9476 23.0303 31.8619 22.9914 31.7675C22.9525 31.6732 22.9325 31.5721 22.9327 31.47V22.5901C22.9327 22.4842 22.9748 22.3826 23.0497 22.3077C23.1246 22.2328 23.2262 22.1907 23.3321 22.1907H24.6925C24.7984 22.1907 24.9 22.2328 24.9749 22.3077C25.0498 22.3826 25.0919 22.4842 25.0919 22.5901V31.5646C25.0919 31.7458 25.0199 31.9196 24.8918 32.0477C24.7637 32.1758 24.5899 32.2478 24.4087 32.2478ZM31.2165 19.1997C31.2165 19.5314 31.0848 19.8495 30.8502 20.0841C30.6156 20.3187 30.2975 20.4504 29.9658 20.4504H27.2315C27.1256 20.4504 27.024 20.4084 26.9491 20.3335C26.8742 20.2586 26.8321 20.157 26.8321 20.051V19.3198C26.8321 19.1328 26.7953 18.9475 26.7236 18.7747C26.652 18.6019 26.547 18.445 26.4147 18.3128C26.2824 18.1806 26.1253 18.0757 25.9524 18.0043C25.7795 17.9329 25.5943 17.8962 25.4072 17.8964H17.8651C17.3576 17.8964 16.9462 17.542 16.9462 17.1066V16.5255C16.9462 16.0901 17.3576 15.7372 17.8651 15.7372H29.9643C30.2959 15.7376 30.6138 15.8695 30.8483 16.104C31.0827 16.3385 31.2146 16.6564 31.215 16.988L31.2165 19.1997Z",
    fill: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iin_1962_12357",
    x: 5.75,
    y: 4.99997,
    width: 37.25,
    height: 37.2501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.529412 0 0 0 0 0.231373 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1962_12357"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.529412 0 0 0 0 0.231373 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1962_12357",
    result: "effect2_innerShadow_1962_12357"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "10 10",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 9377
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_1962_12357",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_1962_12357"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_1962_12357"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1962_12357",
    x1: 42,
    y1: 5.99997,
    x2: 5.99992,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A173FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ac601565883efc0978afef443daeb7a8.svg";
export { ForwardRef as ReactComponent };